import { CustomReportConfig } from "@/component/common/report/reportConfigModel"


type AlertMenuType = Required<CustomReportConfig>['alertMenu']


export const getContents = (content:string)=>{
  let contents:string[] = []
  // let content = '${alert_high_visit_low_sales_day}天内访问量 >${alert_high_visit_low_sales_visit}订货量 <${alert_high_visit_low_sales_orders_number}'
  while(content.length){
    let variableResult = content.match(/\${\w+}/)
    if(!variableResult){
      contents.push(content)
      break
    }
    let variable = variableResult[0]
    contents.push(content.slice(0,variableResult.index))
    contents.push(variable.slice(2,-1))
    content = content.slice((variableResult.index || 0)+variable.length)
  }
  return contents
}
export const getText = (item:string)=>{
  if(item == ''){
    return ''
  }
  return item
  // return item.replaceAll(' ','\&nbsp;')
}
export const getSelectText =(variableInfo:AlertMenuType['variable']['0'])=>{
  let select = variableInfo.drop_down_option?.find((option)=>option.value == variableInfo.key_value)
  if(select){
    return select.label
  }
  return ''
}
export const getInputText= (variableInfo:AlertMenuType['variable']['0'])=>{
  return variableInfo.key_value
}
